import { render, staticRenderFns } from "./copyAgentApp.vue?vue&type=template&id=1b964f14&scoped=true&"
import script from "./copyAgentApp.vue?vue&type=script&lang=js&"
export * from "./copyAgentApp.vue?vue&type=script&lang=js&"
import style0 from "./copyAgentApp.vue?vue&type=style&index=0&id=1b964f14&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b964f14",
  null
  
)

export default component.exports